module.exports = __webpack_public_path__ + "img/arch-project-640.4c04f7cb.jpg";